






























































import { Component, Vue } from 'vue-property-decorator'
import App from '../App.vue'
import axios from 'axios'
import { ProductDataList } from '../models/ProductDataList'
import { ProductData } from '../models/ProductData'
import { EnumHelpers, ProductOrToolType, UsageType } from '../helpers/EnumHelpers'
import RowActions from '../components/RowActions.vue'
import ProductDialog from '../components/ProductDialog.vue'
import ProductVersionsDialog from '../components/ProductVersionsDialog.vue'
import ErrorDialog from '../components/ErrorDialog.vue'
import { FailureResponseData } from '../models/FailureResponseData'
import { ErrorHandlingHelpers } from '@/helpers/ErrorHandlingHelpers'

@Component({
  components: { RowActions, ProductDialog, ProductVersionsDialog, ErrorDialog },
})
export default class Products extends App {
  private errorDialogIsShown: boolean = false
  private failure: FailureResponseData = new FailureResponseData()
  private search: string = ''
  private items: Array<ProductData> = []
  private headers = [{ text: 'Name', value: 'name' }, { text: 'Type', value: 'type' }, { text: 'Actions', value: 'actions' }]

  private productDialogShown: boolean = false
  private productDialogIsEditing: boolean = false
  private productVersionsDialogShown: boolean = false
  private itemToBeEdited: ProductData = new ProductData('', '', ProductOrToolType.Other, '', '', '', '', '', '', [], false, '', false)

  private get getHeaders() {
    if (this.$auth.canManage) {
      return this.headers
    } else {
      return this.headers.filter((h) => h.text !== 'Actions')
    }
  }

  private getType(type: number) {
    return EnumHelpers.GetFlaggedProductOrToolTypesString(type)
  }

  private getUsageType(type: number) {
    return EnumHelpers.GetUsageType(type)
  }

  private getColor(type: number) {
    return EnumHelpers.GetColor(type)
  }

  private async deleteProduct(item) {
    try {
      let errorsOccurred: boolean = false
      let errorObject: FailureResponseData = new FailureResponseData()
      await axios.delete<ProductData>(`Products/${item.id}`).catch((error) => {
        errorsOccurred = true
        errorObject = ErrorHandlingHelpers.getFailureMessage(error)
      })

      if (errorsOccurred) {
        this.failure = errorObject
        this.errorDialogIsShown = true
      } else {
        this.items = this.items.filter((i) => i !== item)
      }
    } catch (e) {
      this.failure = new FailureResponseData(e.message)
      this.errorDialogIsShown = true
    }
  }

  private addProduct(newProductData: ProductData) {
    this.items.push(newProductData)
    this.items = this.items.sort((t1, t2) => {
      if (t1.name < t2.name) {
        return -1
      } else if (t1.name > t2.name) {
        return 1
      } else {
        return 0
      }
    })
  }
  private editProduct(oldProductData: ProductData, newProductData: ProductData) {
    oldProductData.name = newProductData.name
    oldProductData.type = newProductData.type
  }

  private initiateEditProduct(item) {
    this.productDialogIsEditing = true
    this.itemToBeEdited = item
    this.productDialogShown = true
  }
  private initiateEditProductVersions(item) {
    this.itemToBeEdited = item
    this.productVersionsDialogShown = true
  }

  private initiateAddProduct(item) {
    this.productDialogIsEditing = false
    this.productDialogShown = true
  }

  private async created() {
    await this.fetchProducts()
  }

  // TODO: Api call being made here this should be made in Vuex to decouple UI from networking.
  private async fetchProducts() {
    try {
      // Use Axios to make a call to the API
      const resp = await axios.get<ProductDataList>('Products', {
        params: {
          count: 1000,
          skip: 0,
        },
      })

      this.items = resp.data.items
    } catch (e) {
      this.showError = true
      this.errorMessage = `Error while loading products: ${e.message}.`
    }
    
    this.loading = false
  }
}
